import { ReachAPI } from './ReachAPI';
import { Log } from '../AuxillaryService/Log';

/**
 * @class stocks
 * @hideconstructor
 * @memberof ReachAPI
 */
ReachAPI.stocks = {};

/**
 * GET Endpoint `/stocks/v3/data/`
 * @param {number} symbols
 * @param {string} playerUuid
 * @throws {jqpFailure}
 * @returns {jqpSuccess}
 * @memberof ReachAPI.stocks
 */
ReachAPI.stocks.getStockQuoteData = function (symbols, playerUuid) {
    var cache_id = '/stocks/v3/data/symbols=' + symbols;
    var url = ReachAPI.server + '/stocks/v3/data';
    var params = {
        symbols: symbols,
        player_uuid: playerUuid,
    };
    var jqPromise;

    jqPromise = ReachAPI.getWithFallback(url, 'json', params, cache_id);

    jqPromise.done(function (data, textStatus) {
        if (textStatus === 'cache') {
            Log.Debug(
                'Retrieved Stock Quote Data from the CACHE (API call failed)',
                null,
                __fileline
            );
        } else {
            Log.Debug('Retrieved Stock Quote Data from the API', null, __fileline);
        }
    });

    jqPromise.fail(function (jqXHR, textStatus, errorThrown, msg, event) {
        Log.Warning(
            'Failed to retrieve Stock Quote Data',
            null,
            __fileline,
            ReachAPI.createPromiseFailObject(jqXHR, textStatus, errorThrown, msg, event)
        );
    });

    return jqPromise;
};

/**
 * GET Endpoint `/stocks/v3/chart_data/`
 * @param {string} symbol
 * @param {string} playerUuid
 * @param {string} interval
 * @param {string} range
 * @throws {jqpFailure}
 * @returns {jqpSuccess}
 * @memberof ReachAPI.stocks
 */
ReachAPI.stocks.getStockChartData = function (symbol, playerUuid, interval, range) {
    var cache_id =
        '/stocks/v3/chart_data/symbol=' + symbol + '&interval=' + interval + '&range=' + range;
    var url = ReachAPI.server + '/stocks/v3/chart_data';
    var params = {
        symbol: symbol,
        player_uuid: playerUuid,
        interval: interval,
        range: range,
    };
    var jqPromise;

    jqPromise = ReachAPI.getWithFallback(url, 'json', params, cache_id);

    jqPromise.done(function (data, textStatus) {
        if (textStatus === 'cache') {
            Log.Debug(
                'Retrieved Stock Chart Data from the CACHE (API call failed)',
                null,
                __fileline
            );
        } else {
            Log.Debug('Retrieved Stock Chart Data from the API', null, __fileline);
        }
    });

    jqPromise.fail(function (jqXHR, textStatus, errorThrown, msg, event) {
        Log.Warning(
            'Failed to retrieve Stock Chart Data',
            null,
            __fileline,
            ReachAPI.createPromiseFailObject(jqXHR, textStatus, errorThrown, msg, event)
        );
    });

    return jqPromise;
};

/**
 * GET Endpoint `/stocks/v3/currency_data/`
 * @param {string} playerUuid
 * @throws {jqpFailure}
 * @returns {jqpSuccess}
 * @memberof ReachAPI.stocks
 */
ReachAPI.stocks.getCurrencyData = function (playerUuid) {
    var cache_id = '/stocks/v3/currency_data/';
    var url = ReachAPI.server + '/stocks/v3/currency_data';
    var params = {
        player_uuid: playerUuid,
    };
    var jqPromise;

    jqPromise = ReachAPI.getWithFallback(url, 'json', params, cache_id);

    jqPromise.done(function (data, textStatus) {
        if (textStatus === 'cache') {
            Log.Debug('Retrieved Currency Data from the CACHE (API call failed)', null, __fileline);
        } else {
            Log.Debug('Retrieved Currency Data from the API', null, __fileline);
        }
    });

    jqPromise.fail(function (jqXHR, textStatus, errorThrown, msg, event) {
        Log.Warning(
            'Failed to retrieve Currency Data',
            null,
            __fileline,
            ReachAPI.createPromiseFailObject(jqXHR, textStatus, errorThrown, msg, event)
        );
    });

    return jqPromise;
};
